module.exports = __webpack_public_path__ + "static/img/download.cb29c61.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/download.png
// module id = Sdxg
// module chunks = 2